<script lang="ts"></script>

<script setup lang="ts">
import { TooltipProvider } from "reka-ui";
import { watchEffect } from "vue";
import { useAppContext } from "../../app-context";
import { ConfirmProvider } from "../confirm";
import { ToastProvider } from "../toast";

const { dark } = defineProps<{
	dark: boolean;
}>();

const appCtx = useAppContext();

watchEffect(() => {
	const theme = dark ? "dark" : "light";
	document.documentElement.setAttribute("data-theme", theme);

	appCtx.dark.value = dark;
});
</script>

<template>
	<TooltipProvider :disabled="appCtx.isMobile.value" :delayDuration="200">
		<slot />
	</TooltipProvider>
	<ToastProvider :theme="dark ? 'dark' : 'light'" richColors closeButtonPosition="top-right" />
	<ConfirmProvider />
</template>
